import React from 'react';
import { trackEvent } from '../utils/ga.js';
import './TranslatorOutput.css';

const TranslatorOutput = ({
                              pageType = 'ko-vn',
                              sourceLang,
                              targetText,
                              isLoading,
                              error,
                              t,
                              copySuccess,
                              handleCopy,
                              handleTTS,
                              openSettings,
                          }) => {

    const renderTargetLanguage = () => {
        if (pageType === 'en-vn') {
            return sourceLang === 'en'
                ? `🇻🇳 ${t('languages.vietnamese')}`
                : `🇬🇧 ${t('languages.english')}`;
        }
        return sourceLang === 'ko'
            ? `🇻🇳 ${t('languages.vietnamese')}`
            : `🇰🇷 ${t('languages.korean')}`;
    };

    return (
        <div className="output-section">
            <div className="output-header-actions">
                <span className="lang-display">
                    {renderTargetLanguage()}
                </span>
            </div>
            <div className="output-top-buttons">
                <button onClick={() => { trackEvent('open_settings'); openSettings(); }} className="settings-button">
                    <span>{t('buttons.settings')}</span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                        <path d="M9.405 1.05c-.413-1.4-2.397-1.4-2.81 0l-.1.34a1.464 1.464 0 0 1-2.105.872l-.31-.17c-1.283-.698-2.686.705-1.987 1.987l.17.31a1.464 1.464 0 0 1-.872 2.105l-.34.1c-1.4.413-1.4 2.397 0 2.81l.34.1a1.464 1.464 0 0 1 .872 2.105l-.17.31c-.698 1.283.705 2.686 1.987 1.987l.31-.17a1.464 1.464 0 0 1 2.105.872l.1.34c.413 1.4 2.397 1.4 2.81 0l.1-.34a1.464 1.464 0 0 1 2.105-.872l.31.17c1.283.698 2.686-.705 1.987-1.987l-.17-.31a1.464 1.464 0 0 1 .872-2.105l.34-.1c-1.4-.413-1.4 2.397 0-2.81l-.34-.1a1.464 1.464 0 0 1-.872-2.105l.17-.31c.698-1.283-.705-2.686-1.987-1.987l-.31.17a1.464 1.464 0 0 1-2.105-.872l-.1-.34zM8 10.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z"/>
                    </svg>
                </button>
                <div className="output-right-group">
                    <div className="output-buttons-group">
                        {copySuccess && <span className="copy-success-message">{t('messages.copySuccess')}</span>}
                        <button onClick={handleTTS} disabled={!targetText || isLoading} className="icon-button" title={t('buttons.listen')}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                                <path d="M11.536 14.01A8.473 8.473 0 0 0 14.026 8a8.473 8.473 0 0 0-2.49-6.01l-1.414 1.414A6.476 6.476 0 0 1 12.025 8a6.476 6.476 0 0 1-1.903 4.6l1.414 1.414zM10.121 12.596A6.48 6.48 0 0 0 12.025 8a6.48 6.48 0 0 0-1.904-4.596l-1.414 1.414A4.486 4.486 0 0 1 10.025 8a4.486 4.486 0 0 1-1.317 3.182l1.414 1.414zM8.707 11.182A4.486 4.486 0 0 0 10.025 8a4.486 4.486 0 0 0-1.318-3.182L7.293 6.23A2.5 2.5 0 0 1 8.025 8a2.5 2.5 0 0 1-.732 1.77l1.414 1.414zM6.717 3.55A.5.5 0 0 1 7 4v8a.5.5 0 0 1-.812.39L3.825 10.5H1.5A.5.5 0 0 1 1 10V6a.5.5 0 0 1 .5-.5h2.325l2.363-1.89a.5.5 0 0 1 .529-.06z"/>
                            </svg>
                        </button>
                        <button onClick={handleCopy} disabled={!targetText || isLoading} className="copy-button-text">
                            {t('buttons.copy')}
                        </button>
                    </div>
                </div>
            </div>
            <div className="text-output">
                {targetText ? (
                    <p className="translated-text">{targetText}</p>
                ) : (
                    <p className="placeholder-text">{error || t('placeholders.target')}</p>
                )}
            </div>
        </div>
    );
};

export default TranslatorOutput;
